import { useTheme } from '@emotion/react';
import { Box, Button, Dialog, Stack, TablePagination, Typography } from '@mui/material';
import { CancelToken } from 'apisauce';
import React from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import appapi from '../../../../api/apiClient';
import { useEffect } from 'react';
import PageHeader from '../../../../components/PageHeader';
import { dialogButtonCancel } from '../../../../utils/commonStyle';
import AddEditContacts from './AddEditContacts';
import ConfirmArchiveDialog from '../../../../components/ConfirmArchiveDialog';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ContactsDetails from './ContactDetails';
import Datatable from '../../../../components/DataTable';
import TablePaginationActions from '../../../../components/TablePaginationActions';
import ArchiveUserList from '../../UserManagement/Components/ArchiveUserList';
import { useTranslation } from 'react-i18next';

const companyType = [
  {
    id: 'ship owner',
    name: 'Ship Owner',
  },
  {
    id: 'ship manager',
    name: 'Ship Manager',
  },
  {
    id: 'operator',
    name: 'Operator',
  },
  {
    id: 'charterer',
    name: 'Charterer',
  },
];

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '100%',
    margin: '8px',
    borderRadius: '4px',
    // maxWidth: '736px',
    height: '100%',
    maxWidth: '100%',
    maxHeight: '90%',
  },
};

export default function ArchiveContactList({ modelOpen, onModelHandleClose }) {
  const columns = [
    {
      id: 0,
      header: '#',
      accessor: 'Sno',
      width: '5%',
      default: true,
      columnEditable: false,
      activeColumn: true,
    },
    {
      id: 1,
      header: 'Company name',
      accessor: 'companyName',
      width: '25%',
      default: true,
      columnEditable: false,
      activeColumn: true,
      capitalize: true,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [],
      },
    },
    {
      id: 2,
      header: 'Company type',
      accessor: 'companyType',
      width: '10%',
      default: true,
      columnEditable: false,
      activeColumn: true,
      capitalize: true,
      filter: {
        search: false,
        filterType: 'checkbox',
        typeFilter: true,
        filterList:
          companyType?.map((item) => {
            return {
              label: item?.name,
              value: item?.id,
            };
          }) || [],
      },
    },
    {
      id: 3,
      header: 'Name',
      accessor: 'name',
      width: '15%',
      default: true,
      columnEditable: true,
      activeColumn: true,
      capitalize: true,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [],
      },
    },
    {
      id: 4,
      header: 'Email',
      accessor: 'email',
      width: '20%',
      default: true,
      columnEditable: true,
      activeColumn: true,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [],
      },
    },
    {
      id: 5,
      header: 'Phone',
      accessor: 'phoneNumber',
      width: '10%',
      default: true,
      columnEditable: true,
      activeColumn: true,
      Cell: (value) => (
        <div className="flex ">
          <Typography
            className="fw-regular ff-Roboto fs-12"
            color={text}
          >
            {value?.phoneCode || ''}
            {'-'}
            {value?.phoneNumber || '-'}
          </Typography>
        </div>
      ),
    },
    {
      id: 6,
      header: 'Country',
      accessor: 'countryName',
      width: '10%',
      default: false,
      columnEditable: true,
      activeColumn: false,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [],
      },
    },
    {
      id: 7,
      header: 'State',
      accessor: 'stateName',
      width: '10%',
      default: false,
      columnEditable: true,
      activeColumn: false,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [],
      },
    },
  ];

  const theme = useTheme();
  const { t } = useTranslation();
  const [search, setSearch] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [contactList, setContactsList] = useState([]);
  const [filter1, setFilter1] = useState([]);
  const [openAddEditContacts, setOpenAddEditContacts] = useState(false);
  const [openRolePrivilage, setOpenRolePrivilage] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [contactDetails, setContactDetails] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [type, setType] = useState('');

  const [selectedHistory, setSelectedHistory] = useState(null);
  const [openArchiveDialog, setOpenArchiveDialog] = useState(false);
  const [openArchiveList, setOpenArchiveList] = useState(false);
  const [reload, setReload] = useState(false);

  const [list, setList] = useState([]);
  const [payload, setPayload] = useState({
    page: 1,
    limit: 10,
    filter: null,
    totalLength: 0,
    paginationPage: 0,
    companyTypeFilter: [],
    field: '_id',
    sortOrder: 'desc',
  });

  const { userId, companyDetails, user } = useSelector((state) => state.auth);

  let source = CancelToken.source();
  const text = theme.palette.primary.text;

  const handleToggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleChangePage = (event, newPage) => {
    setPayload((prevState) => ({ ...prevState, page: newPage + 1, paginationPage: newPage, filter: payload.filter }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPayload((prev) => ({ ...prev, limt: parseInt(event.target.value, 10), paginationPage: 1, page: 1, filter: payload.filter }));
  };

  //search filter
  const handleSearchEmit = (search) => {
    setPayload((prevState) => ({ ...prevState, paginationPage: 0, page: 1, filter: search }));
  };

  const handleOnChangeCheckBox = (index, checkedStatus, item) => {
    setSelectedHistory(checkedStatus ? item : null);
  };

  const handleOnArchive = (item) => {
    setOpenArchiveDialog(true);
  };

  useEffect(() => {
    setList(
      contactList.map((res, index) => {
        return {
          ...res,
          Sno : payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1,
          isSelected: false,
        };
      }),
    );
  }, [contactList]);

  useEffect(() => {
    if (list.length > 0) {
      if (selectedHistory) {
        const items = list.map((res) => {
          return {
            ...res,
            isSelected: res._id === selectedHistory._id,
          };
        });
        setList(items);
      } else {
        const items = list.map((res) => {
          return {
            ...res,
            isSelected: false,
          };
        });
        setList(items);
      }
    }
  }, [selectedHistory]);

  const handleGetContacts = async (fromSearch = true) => {
    setIsLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `/contact-management/allArchiveList/companyContacts`,
      {
        pageNumber: payload.page,
        filter: payload.filter || null,
        pageSize: payload.limit,
        companyTypeFilter: payload.companyTypeFilter,
        sortOrderField: payload.field === 'companyName' ? 'sortCompanyName' : payload.field === 'name' ? 'sortName' : payload.field,
        sortOrder: payload.sortOrder,
        companyId: user?.companyId,
      },
      { cancelToken: source.token },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        let userData = data?.response?.response;
        userData.map((item, index) => {
          item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
          return item;
        });
        setContactsList(userData);
        setPayload((prev) => ({ ...prev, totalLength: data?.response?.length, paginationPage: payload.page === 1 ? 0 : payload.page - 1 }));
        setIsLoading(false);
      } else {
        setContactsList([]);
        setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 0 }));
        setIsLoading(false);
      }
    } else {
      setContactsList([]);
      setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 1 }));
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    handleGetContacts();
    return () => {
      if (source) {
        source.cancel();
      }
    };
    // eslint-disable-next-line
  }, [payload.page, payload.filter, payload.field, payload.sortOrder, payload.companyTypeFilter]);

  const selectRow = (sitem, sindex) => {
    const contacts = contactList.map((item, index) => {
      item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
      item.selected = item._id === sitem._id;
      return item;
    });
    setSelectedData(sitem);
    setContactsList(contacts);
    setIsDrawerOpen(true);
  };

  const handleExcelDownload = async (format) => {
    const response = await appapi.get(
      `/contact-management/archiveCompanyContacts/excel`,
      {
        filter: payload.filter || null,
        companyTypeFilter: payload.companyTypeFilter,
        sortOrderField: payload.field === 'companyName' ? 'sortCompanyName' : payload.field === 'namen' ? 'sortName' : payload.field,
        sortOrder: payload.sortOrder,
        companyId: user?.companyId,
        format,
      },
      { observe: 'response', responseType: 'blob' },
    );
    if (response.ok) {
      try {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        const ext = format === 'csv' ? 'csv' : 'xlsx';
        link.download = `ARCHIVEDCONTACT${new Date().getTime()}.${ext}`;
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error downloading:', error);
      }
    } else {
    }
  };

  const [customerManagementColumn, setCustomerManagementColumn] = useState(columns);

  return (
    <Dialog
      sx={sx}
      open={modelOpen}
    >
      <Stack
        flex={1}
        direction={'row'}
        className="m-[8px] rounded-[8px] bg-white"
      >
        <Stack flex={1}>
          <PageHeader
            handleFilterButton={payload.totalLength > 0 ? true : false}
            handleOnSearchEmit={(search) => {
              handleSearchEmit(search);
            }}
            showExport={payload.totalLength > 0 ? true : false}
            onExport={(type) => {
              handleExcelDownload(type);
            }}
            isArchive={true}
            showArchive={true}
            disableArchive={selectedHistory ? false : true}
            onArchive={(item) => handleOnArchive(item)}
            columnPreference={payload.totalLength > 0 ? true : false}
            columns={customerManagementColumn}
            applyColumnPreference={(c) => setCustomerManagementColumn(c)}
            onRefresh={() => {
              if (payload.page === 1) {
                handleGetContacts();
              } else {
                setPayload((prevState) => ({ ...prevState, paginationPage: 0, page: 1 }));
              }
            }}
          >
            <Stack
              direction="row"
              flex={1}
            >
              <Stack flexGrow={1} />
              {/* <Button
                sx={{ color: theme.palette.primary.main }}
                className="fs-14 ff-Roboto fw-medium !mr-[20px]"
                onClick={() => {
                  setOpenAddEditContacts(true);
                  setType('add');
                  setContactDetails(null);
                }}
                variant="text"
                startIcon={<PersonAddIcon />}
              >
                ADD CONTACT
              </Button> */}
            </Stack>
          </PageHeader>
          <Stack
            flexGrow={1}
            className="relative flex-auto overflow-auto h-0"
          >
            <Datatable
              tableHeadBgColor={'#e2eeff'}
              columns={customerManagementColumn.filter((res) => res.activeColumn)}
              data={list || []}
              isLoading={isLoading}
              showCheckBox={true}
              onChangeCheckBox={handleOnChangeCheckBox}
              onClickRow={(item, index) => {
                selectRow(item, index);
              }}
              onChangeFilter={(filterValues) => {
                const sortValues = filterValues?.sort;
                let columnUpdate = customerManagementColumn;
                columnUpdate[filterValues?.id].filter[`selectValue`] = filterValues?.filter.selectValue;
                if (sortValues) {
                  columnUpdate = columnUpdate.map((res) => {
                    return {
                      ...res,
                      sortOrder: sortValues.field === res.accessor ? sortValues.order : null,
                    };
                  });
                }
                setCustomerManagementColumn(columnUpdate);
                if (sortValues) {
                  setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, field: sortValues.field, sortOrder: sortValues.order, companyTypeFilter: filterValues?.filter.selectValue }));
                } else {
                  setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, companyTypeFilter: filterValues?.filter.selectValue }));
                }
              }}
            />
          </Stack>

          <Stack
            sx={{ width: '100%' }}
            className="relative inputFormStyle"
            direction={'row'}
          >
            <Button
              sx={[
                dialogButtonCancel,
                {
                  color: theme.palette.primary.main,
                  fontSize: '14px',
                  '&:hover': {},
                },
              ]}
              style={{ width: '230px', height: '48px' }}
              onClick={() => {
                onModelHandleClose(reload);
              }}
            >
              {t('Close')}
            </Button>
            <Box className="flex  justify-end items-center h-[56px] w-[100%] p-[5px]">
              <TablePagination
                sx={{ borderBottom: 0 }}
                rowsPerPageOptions={[]}
                count={payload.totalLength ? payload.totalLength : 0}
                rowsPerPage={payload.limit ? payload.limit : 10}
                page={payload.paginationPage ? payload.paginationPage : 0}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </Box>
          </Stack>
        </Stack>
        <Stack>
          {isDrawerOpen && <ContactsDetails
            isDrawerOpen={isDrawerOpen}
            toggleDrawer={() => {
              if (selectedData) {
                handleToggleDrawer();
              }
            }}
            openEditContacts={(data) => {
              setOpenAddEditContacts(true);
              setContactDetails(data);
              setType('edit');
            }}
            contact={selectedData}
            init={() => handleGetContacts()}
          />}
          
        </Stack>
        {openAddEditContacts && (
          <AddEditContacts
            contact={contactDetails}
            modelOpen={openAddEditContacts}
            onModelHandleClose={(event) => {
              if (event) {
                setPayload((prev) => ({ ...prev, page: 1 }));
                handleGetContacts();
              }
              setOpenAddEditContacts(false);
            }}
            type={type}
          />
        )}
        {openArchiveDialog && (
          <ConfirmArchiveDialog
            modelOpen={openArchiveDialog}
            onModelHandleClose={(event) => {
              if (event) {
                setOpenArchiveDialog(false);
                setOpenArchiveList(false);
                setPayload((prev) => ({ ...prev, page: 1 }));
                handleGetContacts();
                setReload(true);
                setSelectedHistory(null)
              }
              setOpenArchiveDialog(false);
            }}
            data={selectedHistory}
            status={0}
            type={'contact'}
          />
        )}
      </Stack>
    </Dialog>
  );
}
